import React, { useCallback, useState, useEffect, createRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const PopularFilters = () => {
  const dispatch = useDispatch();
  const { popularFilters, facetFilters: globalFacetFilters } = useSelector(
    (state) => state.facetedSearch
  );
  const wrapperRef = createRef();

  const [_, setFacetFilters] = useState(globalFacetFilters || []);
  useEffect(() => {
    setFacetFilters(globalFacetFilters);
  }, [globalFacetFilters]);

  const hasPopularFilters = popularFilters && popularFilters.length > 0;

  useEffect(() => {
    if (!hasPopularFilters && popularFilters != null) {
      wrapperRef.current.parentElement.style.minHeight = 'initial';
    }
  }, [hasPopularFilters]);

  return (
    <div
      className={`search__popular-filters-wrapper ${
        hasPopularFilters ? 'has-filters' : 'has-no-filters'
      }`}
      ref={wrapperRef}
    >
      {popularFilters && popularFilters.length > 0 && (
        <>
          <h4 className="search__popular-filters-title">
            {translate('search.popular.filters')}
          </h4>
          {popularFilters.map((item, itemIndex) => (
            <div
              key={'popular-filter-' + itemIndex}
              className="search__popular-filters-items"
            >
              <span className="search__popular-filters-label">{item.label}: </span>
              {item.options &&
                item.options.map((filter, filterIndex, array) => (
                  <li
                    key={`${filter.label}-${filterIndex}`}
                    className="faceted-search__item"
                    role="faceted-search-item"
                  >
                    <FacetedFilterCheckbox item={filter} group={item} />
                  </li>
                ))}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

const FacetedFilterCheckbox = ({ item, group }) => {
  const dispatch = useDispatch();
  const onChange = useCallback(
    (group, item) => dispatch(searchFacetChange(group, item)),
    [dispatch]
  );
  return (
    <label className="faceted-filter">
      <div className="faceted-filter__input--wrapper">
        <input
          className="faceted-filter__input"
          type="checkbox"
          onChange={(event) => onChange(group, item)}
          checked={
            group.selectedOptions != null &&
            group.selectedOptions.includes(item.id)
          }
        />
        <span className="faceted-filter__label">{item.label}</span>
      </div>
      {!isNaN(item.quantity) && item.quantity != null && (
        <span className="faceted-filter__quantity">
          &nbsp;({item.quantity})
        </span>
      )}
    </label>
  );
};

export default PopularFilters;
